<nb-card accent="success">
  <nb-card-header>
    <div class="d-flex">
      <div class="flex-grow-1 d-flex align-items-center justify-content-center">
        <nb-icon icon="settings-outline"></nb-icon>
        <div class="ml-2" i18n>Select which columns to display</div>
      </div>
      <button nbButton class="ml-3" (click)="cancel()">
        <nb-icon icon="close-outline"></nb-icon>
      </button>
    </div>
  </nb-card-header>
  <nb-card-body>
    <div class="row" style="width: 650px">
      <div class="col-4" *ngFor="let column of columns">
        <nb-checkbox status="success" [checked]="checked[column]" (checkedChange)="toggle(column, $event)">
          {{ column | replaceunderscore }}
        </nb-checkbox>
      </div>
    </div>
  </nb-card-body>
  <nb-card-footer>
    <div class="d-flex justify-content-end">
      <button nbButton status="danger" (click)="cancel()" i18n>Cancel</button>
      <button nbButton class="ml-3" status="success" (click)="save()" i18n>Save</button>
    </div>
  </nb-card-footer>
</nb-card>
